import React from 'react';
import ReactApexChart from "react-apexcharts";

const SecurityHealthTracker = ({ value = [], data = [], brand = [], date = [], color = "#FFC90A" }) => {
    // Find the maximum value to set y-axis domain
    let largest = 0;
    for (let i = 0; i < value.length; i++) {
        largest = Math.max(largest, value[i], data[i], brand[i]);
    }

    // Chart configuration
    const chartOptions = {
        chart: {
            height: 285,
            type: 'area',
            toolbar: {
                show: false
            },
            animations: {
                enabled: true,
                easing: 'easeinout'
            },
            grid: {
                padding: {
                    right: 10 // Add padding to ensure last point is visible
                }
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#FFC90A', '#1DBF73', '#3FC8E4'],
        markers: {
            size: 3,
            strokeColor: ['#FFC90A', '#1DBF73', '#3FC8E4'],
            hover: {
                size: 6,
                sizeOffset: 3 // Add size offset for better hover detection
            }
        },
        stroke: {
            width: 2,
            curve: 'smooth',
        },
        xaxis: {
            type: 'category',
            axisTicks: { show: false },
            axisBorder: { show: false },
            categories: date
        },
        yaxis: {
            tickAmount: 8,
            min: 0,
            max: parseInt(largest) + 50
        },
        legend: {
            show: false
        },
        tooltip: {
            enabled: true,
            intersect: false,
            shared: true,
            followCursor: true,
            theme: 'dark',
            y: {
                formatter: function (value) {
                    return value;
                }
            },
            style: {
                color: '#ffffff',
                fontSize: '12px',
                lineHeight: '14px',
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const labels = w.config.series.map(s => s.name);
                return `
          <div style="
            background: black;
            color: white;
            padding: 6px 10px;
            border-radius: 6px;
            font-size: 12px;
            line-height: 14px;
          ">
            <strong style="color: #fff;">${w.globals.categoryLabels[dataPointIndex]}</strong><br />
            ${labels.map((label, i) => `
              <div style="display: flex; align-items: center; gap: 5px; margin-top: 2px;">
                <span style="width: 8px; height: 8px; background: ${w.config.colors[i]}; display: inline-block; border-radius: 50%;"></span>
                ${label}: ${series[i][dataPointIndex]}
              </div>
            `).join('')}
          </div>
        `;
            }
        },
    };

    const series = [
        {
            name: "Attack Surface",
            data: value
        },
        {
            name: 'Data Exposure',
            data: data
        },
        {
            name: 'Brand Security',
            data: brand
        }
    ];

    // Custom legend component from the original design
    const Legend = () => (
        <div style={{
            display: 'flex',
            gap: '24px',
            marginBottom: '20px',
            fontSize: '14px',
            fontWeight: 500
        }}>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 600, gap: '5px', color: "#211F54" }}>
                <span style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#FFC90A',
                    borderRadius: '3px',
                    display: 'inline-block'
                }}></span>
                Attack Surface
            </div>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 600, gap: '5px', color: "#211F54" }}>
                <span style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#1DBF73',
                    borderRadius: '3px',
                    display: 'inline-block'
                }}></span>
                Data Exposure
            </div>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 600, gap: '5px', color: "#211F54" }}>
                <span style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: '#3FC8E4',
                    borderRadius: '3px',
                    display: 'inline-block'
                }}></span>
                Brand Security
            </div>
        </div>
    );

    return (
        <div>
            <Legend />
            <ReactApexChart
                options={chartOptions}
                series={series}
                type="area"
                height="285px"
                className="chart-class"
            />
        </div>
    );
};

export default SecurityHealthTracker;
